import {
  InputAdornment,
  TextField,
  Tooltip,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import ModalToShowAnExerciseInfo from "../Workout/components/ModalToShowAnExerciseInfo";
import { formatWithLeadingZeros } from "src/utils/constant";
import CustomComplateFeild from "./CustomComplateFeild";

const AMRAPExercisesUI = ({
  addArray,
  setaddArray,
  memberId,
  mainindex,
  message,
  isPersonal,
  isSidebar,
  isWithHistoryAndBigScreen,
}) => {
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");

  const handleArrowSuperSet = (value, index, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["emomSets"][index][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  return (
    <div className="my-2">
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      <div className="characters mt-2">
        <div
          style={{ position: "relative" }}
          className="workout-Superset-card my-1"
        >
          <Box>
            <div className="row mb-3">
              <div
                className={`col-sm-12 col-md-2 col-lg-2 order-2 order-md-1 text-center text-md-start`}
              >
                <Tooltip placement="top" title={message}>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    label="Interval Duration"
                    InputLabelProps={{
                      className: "textfiels-input-label",
                      shrink: true,
                      style: { fontSize: "14px" },
                    }}
                    InputProps={{
                      className: "textfiels-input-value",
                      style: {
                        fontSize: "13px",
                        paddingLeft: "0px",
                        paddingRight: "0px",

                        justifyContent: "center",
                      },
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <TextField
                            id="outlined-basic-minutes"
                            type="number"
                            size="small"
                            placeholder="Min"
                            value={formatWithLeadingZeros(
                              Math.floor(addArray[mainindex].time_interval / 60)
                            )}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "19px",
                                fontWeight: "500",
                              },
                              readOnly: true,
                            }}
                            sx={{
                              "& fieldset": {
                                border: "none",
                              },
                              "& input": {
                                textAlign: "center",
                                padding: "0px",
                              },
                              width: "100%",
                            }}
                          />
                          <div className="fs-4 fw-semibold ">:</div>

                          <TextField
                            id="outlined-basic-seconds"
                            type="number"
                            size="small"
                            placeholder="Sec"
                            value={formatWithLeadingZeros(
                              addArray[mainindex].time_interval % 60
                            )}
                            InputProps={{
                              className: "textfiels-input-value",
                              style: {
                                fontSize: "19px",
                                fontWeight: "500",
                              },
                              readOnly: true,
                            }}
                            sx={{
                              "& fieldset": {
                                border: "none",
                              },
                              "& input": {
                                textAlign: "center",
                                padding: "0px",
                              },
                              width: "100%",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      borderRadius: "5px",
                      fontSize: "13px",
                      "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          width: "0px !important",
                          padding: "9px 0px !important",
                        },
                      "& .css-1nuss9t": {
                        width: "0px !important",
                        padding: "9px 0px !important",
                      },
                      width: "110px",
                    }}
                  />
                </Tooltip>
              </div>
              <div className={`col-sm-12 col-md-8 col-lg-8 order-3 order-md-2`}>
                <div className="d-flex align-items-center justify-content-center text-center text-md-start  my-2">
                  <div>
                    As Many Rounds and Reps as possible in{" "}
                    {formatWithLeadingZeros(
                      Math.floor(addArray[mainindex].time_interval / 60)
                    )}
                    :
                    {formatWithLeadingZeros(
                      addArray[mainindex].time_interval % 60
                    )}{" "}
                    minutes
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-2 col-lg-2  cross-icon order-1 order-md-3 d-flex justify-content-end">
                <Tooltip placement="top" title={message}>
                  <RemoveCircleOutlineIcon className="diary-icon-remove" />
                </Tooltip>
                <Tooltip placement="top" title={message}>
                  <AddCircleOutlineIcon className="diary-icon-add" />
                </Tooltip>
                <CustomPopoverSection menu={[]} data={mainindex} />
              </div>
            </div>
            {addArray[mainindex].emomSets.length > 0 &&
              addArray[mainindex].emomSets.map((item, index) => {
                return (
                  <div className="my-2">
                    <div className="d-flex justify-content-between align-items-center ">
                      <div className="fs-5">Movements</div>
                    </div>
                    {item.length > 0 &&
                      item.map((exerData, exerIndex) => {
                        return (
                          <CustomComplateFeild
                            exerData={exerData}
                            message={message}
                            handleArrowSuperSet={handleArrowSuperSet}
                            handleClickOpen={handleClickOpen}
                            isSidebar={isSidebar}
                            isWithHistoryAndBigScreen={
                              isWithHistoryAndBigScreen
                            }
                            memberId={memberId}
                            index={index}
                            exerIndex={exerIndex}
                          />
                        );
                      })}
                  </div>
                );
              })}
            {isPersonal && (
              <div className="row">
                <div className=" col-12 col-md-12 col-lg-3 d-flex align-items-center justify-content-start justify-content-md-center justify-content-lg-end mt-3 ">
                  <div style={{ whiteSpace: "nowrap" }}>
                    Full Rounds Completed
                  </div>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    placeholder=""
                    type="number"
                    value={addArray[mainindex].amrap_completed_rounds}
                    name="amrap_completed_rounds"
                    InputLabelProps={{
                      className: "textfiels-input-label",
                      shrink: true,
                      style: { fontSize: "14px" },
                    }}
                    InputProps={{
                      className: "textfiels-input-value",
                      style: { fontSize: "13px", padding: "0" },
                      readOnly: true,
                    }}
                    sx={{
                      mx: 1,
                      borderRadius: "5px",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontSize: "13px",
                      "& input": {
                        padding: "3px 5px",
                        textAlign: "center",
                      },
                      width: "33px",
                    }}
                  />{" "}
                  ,
                </div>
                <div className=" col-12 col-md-12 col-lg-9 d-flex align-items-center justify-content-center justify-content-lg-start ">
                  <div className="row w-100">
                    <div className="col-10 col-md-7 col-lg-6 mt-3 d-flex align-items-center justify-content-center  p-md-0">
                      <div className="">
                        How far did you get on your last round?
                        <TextField
                          id="outlined-basic"
                          size="small"
                          variant="outlined"
                          placeholder=""
                          type="number"
                          value={addArray[mainindex].last_amrap_exercise_rounds}
                          name="last_amrap_exercise_rounds"
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: { fontSize: "13px", padding: "0" },
                            readOnly: true,
                          }}
                          sx={{
                            ml: 1,
                            borderRadius: "5px",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            fontSize: "13px",
                            "& input": {
                              padding: "3px 5px",
                              textAlign: "center",
                            },
                            width: "33px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-5 col-lg-6 mt-3 d-flex align-items-center justify-content-start justify-content-lg-start">
                      <div className="me-2">of </div>
                      <FormControl className="me-4">
                        <InputLabel id="demo-simple-select-label" shrink={true}>
                          Exercise
                        </InputLabel>
                        <Select
                          className="set-Type-value"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="last_amrap_exercise"
                          value={addArray[mainindex].last_amrap_exercise}
                          label="Exercise"
                          readOnly={true}
                          InputLabelProps={{
                            className: "textfiels-input-label",
                            shrink: true,
                            style: { fontSize: "14px" },
                          }}
                          InputProps={{
                            className: "textfiels-input-value",
                            style: { fontSize: "13px", padding: "0" },
                          }}
                          sx={{
                            fontSize: "13px",

                            "& .MuiOutlinedInput-input": {
                              padding: "3px 5px",
                            },
                          }}
                        >
                          {addArray[mainindex].emomSets[0].map(
                            (exerData, i) => {
                              return (
                                <MenuItem
                                  key={i}
                                  value={exerData?.exercise?._id}
                                >
                                  {exerData?.exercise?.title}
                                </MenuItem>
                              );
                            }
                          )}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};
export default AMRAPExercisesUI;
